/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoryUpdatePayloadRequest
 */
export interface CategoryUpdatePayloadRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryUpdatePayloadRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryUpdatePayloadRequest
     */
    description: string;
}

/**
 * Check if a given object implements the CategoryUpdatePayloadRequest interface.
 */
export function instanceOfCategoryUpdatePayloadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function CategoryUpdatePayloadRequestFromJSON(json: any): CategoryUpdatePayloadRequest {
    return CategoryUpdatePayloadRequestFromJSONTyped(json, false);
}

export function CategoryUpdatePayloadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryUpdatePayloadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
    };
}

export function CategoryUpdatePayloadRequestToJSON(value?: CategoryUpdatePayloadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
    };
}

